export default __webpack_public_path__ + "files/media/cal-s.83b1c15a.png";